const actions = {
    GET_SERVICE_DATA: 'GET_SERVICE_DATA',
    GET_SERVICE_DATA_SUCCESS: 'GET_SERVICE_DATA_SUCCESS',
    GET_SERVICE_DATA_FAILED: 'GET_SERVICE_DATA_FAILED',
    SERVICE_RESET:'SERVICE_RESET',
    DELETE_SERVICE: 'DELETE_SERVICE',
    DELETE_SERVICE_SUCCESS: 'DELETE_SERVICE_SUCCESS',
    DELETE_SERVICE_FAILED: 'DELETE_SERVICE_FAILED',
    SERVICE_RESET_MESSAGE:'SERVICE_RESET_MESSAGE',
    OPEN_SERVICE_FORM:"OPEN_SERVICE_FORM",
    ADD_SERVICE_SUCCESS:"ADD_SERVICE_SUCCESS",
    ADD_SERVICE_FAILED:"ADD_SERVICE_FAILED",
    ADD_SERVICE: 'ADD_SERVICE',
    ADD_SERVICE_SUCCESS: 'ADD_SERVICE_SUCCESS',
    ADD_SERVICE_FAILED: 'ADD_SERVICE_FAILED',
    
    getServiceData: (offset, limit, search, fromDate, toDate) => ({
      type: actions.GET_SERVICE_DATA,
      payload: { offset, limit, search, fromDate, toDate },
    }),
    getServiceDataSuccess: (data, totalData) => ({
      type: actions.GET_SERVICE_DATA_SUCCESS,
      payload: { data, totalData },
    }),
    getServiceDataFailed: (error) => ({
      type: actions.GET_SERVICE_DATA_FAILED,
      payload: { error },
    }),    
    deleteService: (id,status) => ({
      type: actions.DELETE_SERVICE,
      payload: { id,status },
    }),
    deleteServiceSuccess: (message) => ({
      type: actions.DELETE_SERVICE_SUCCESS,
      payload: { message },
    }),
    deleteServiceFailed: (error) => ({
      type: actions.DELETE_SERVICE_FAILED,
      payload: { error },
    }),
    ServiceResetMessage: () => ({
      type: actions.SERVICE_RESET_MESSAGE,
    }),
    openForm: () => ({
      type: actions.OPEN_SERVICE_FORM,
    }),
    ServiceReset: () => ({
      type: actions.SERVICE_RESET,
    }),
    addService: (data) => ({
      type: actions.ADD_SERVICE,
      payload: { data },
    }),
    addServiceSuccess: (message) => ({
      type: actions.ADD_SERVICE_SUCCESS,
      payload: { message },
    }),
    addServiceFailed: (error) => ({
      type: actions.ADD_SERVICE_FAILED,
      payload: { error },
    }),

    addService: (data) => ({
      type: actions.ADD_SERVICE,
      payload: { data },
    }),
    addServiceSuccess: (message) => ({
      type: actions.ADD_SERVICE_SUCCESS,
      payload: { message },
    }),
    addServiceFailed: (error) => ({
      type: actions.ADD_SERVICE_FAILED,
      payload: { error },
    }),
  
  };
  
  export default actions;